export default __webpack_public_path__ + "static/media/logo.257949f1.png";